import React, {
    PureComponent
} from 'react';
import AnimatedView from '../../../components/componentsGeneral/AnimatedView/AnimatedView';
import ShipmentDetailsContainer from '../../../components/componentsControlTower/ShipmentDetails/ShipmentDetailsContainer';
import LoadTenderDetailsContainer from '../../../components/componentsControlTower/LoadTenderDetails/LoadTenderDetailsContainer';

class ctrlTwrLoadTenderDetailsView extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }


    componentDidMount() {

    }

    render() {

        return (
            <AnimatedView>
                <LoadTenderDetailsContainer isMobile={this.props.isMobile} warehouseSelection={this.props.warehouseSelection} customerSelection={this.props.customerSelection}/>
            </AnimatedView>

        );
    }
}

export default ctrlTwrLoadTenderDetailsView;
